import { useState } from '@wordpress/element';
import { SimpleInput, useToast } from '@getdokan/dokan-ui';
import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import { DokanButton, DokanModal, RichText } from '@dokan/components';
import { Plus } from 'lucide-react';

function NewTicket( { currentLogedinVendor, getTickets } ) {
    const [ isOpen, setIsOpen ] = useState( false );
    const [ subject, setSubject ] = useState( '' );
    const [ ticketDetails, setTicketDetails ] = useState( '' );
    const [ creating, setCreating ] = useState( false );
    const toast = useToast();
    const handleSubmit = async () => {
        if ( ! subject || ! ticketDetails ) {
            toast( {
                type: 'error',
                title: __(
                    'Please write ticket subject and ticket details',
                    'dokan'
                ),
            } );
            return;
        }

        setCreating( true );
        try {
            await apiFetch( {
                path: '/dokan/v1/vendor-support/tickets',
                method: 'POST',
                data: {
                    subject,
                    message: ticketDetails,
                    ...( currentLogedinVendor &&
                        currentLogedinVendor?.id && {
                            vendor_id: currentLogedinVendor.id,
                        } ),
                },
            } );

            // Reset form and close modal on success
            setSubject( '' );
            setTicketDetails( '' );
            setIsOpen( false );

            // Refresh tickets list
            await getTickets();
            toast( {
                type: 'success',
                title: __( 'Ticket created successfully', 'dokan' ),
            } );
        } catch ( error ) {
            // Error handling could be improved based on your needs
            toast( {
                type: 'error',
                title: __( 'Failed to create ticket', 'dokan' ),
            } );
        } finally {
            setCreating( false );
        }
    };
    return (
        <>
            <DokanButton
                onClick={ () => setIsOpen( true ) }
                className="!h-[40px]"
            >
                <Plus size={ 15 } />
                { __( 'Add New Ticket', 'dokan' ) }
            </DokanButton>

            <DokanModal
                namespace="dokan-add-new-vendor-support-modal"
                isOpen={ isOpen }
                onClose={ () => setIsOpen( false ) }
                dialogTitle={ __( 'Add New Ticket', 'dokan' ) }
                dialogContent={
                    <div>
                        <SimpleInput
                            // className="bg-white !h-[37px] "
                            onChange={ ( e ) => setSubject( e.target.value ) }
                            value={ subject }
                            label={ __( 'Subject', 'dokan' ) }
                            input={ {
                                id: 'dokan-add-new-support-ticket',
                                name: 'dokan_add_new_support_ticket',
                                type: 'text',
                                autoComplete: 'off',
                                placeholder: __( 'Enter Subject', 'dokan' ),
                                required: true,
                            } }
                        />
                        <div className="mt-4">
                            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                            <label className="cursor-pointer text-sm font-medium leading-[21px] text-gray-900 mb-2 inline-block">
                                { __( 'Ticket Details', 'dokan' ) }
                            </label>
                            <RichText
                                placeholder={ __( 'Write reply', 'dokan' ) }
                                value={ ticketDetails }
                                onChange={ setTicketDetails }
                                readOnly={ creating }
                            />
                        </div>
                    </div>
                }
                dialogFooter={
                    <div className="flex items-center justify-end gap-2 mb-4 mr-4">
                        <DokanButton
                            variant="secondary"
                            onClick={ () => setIsOpen( false ) }
                            disabled={ creating }
                            label={ __( 'Cancel', 'dokan' ) }
                        />
                        <DokanButton
                            onClick={ handleSubmit }
                            disabled={ creating }
                            loading={ creating }
                            label={ __( 'Submit', 'dokan' ) }
                        />
                    </div>
                }
                className="!w-full md:!min-w-[700px]"
                isDismissible={ false }
            />
        </>
    );
}

export default NewTicket;
